var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-block d-lg-flex"},[_c('div',{staticClass:"wishlists-icon-container collection-icon",class:[!_vm.inWishlist && 'd-none'],on:{"click":_vm.onClick}},[_c('font-awesome-icon',{staticClass:"icon-trash cursor-pointer",attrs:{"icon":['fas', 'trash'],"size":"1x"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }